import classNames from 'classnames';
import { forwardRef } from 'react';
const badgeCss = "b1v6c412";
export const Badge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(badgeCss, props.className)} />;
});

// Export CSS classes for external usage
export { badgeCss };

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");